<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Upload details</template>

    <div class="mx-4 mt-2.5 h-px bg-[#d4d8e1]" />
    <Sheet.Body>
      <UploadDetailsBody />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'
import UploadDetailsBody from './UploadDetailsBody.vue'

const { close } = useSheet()
</script>
